import React from 'react';
import ReactDOM from 'react-dom/client';
import States from './States';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <States />
  </React.StrictMode>
);

